module.exports = __webpack_public_path__ + "img/9.0cb8560f.png";